import LetterSignature from './signature/LetterSignature.js';
export default class SignableLetter {

    static fromData(data) {
        let letter = new SignableLetter();
        letter.id = data.id;
        letter.signatures = data.signatures.map(s => new LetterSignature(s.id, s.type, s.coordinates, s.name, s.signed, s.declined, s.actor, s.signedAt, s.declinedAt, s.signable, s.mandatory));
        letter.title = data.title;
        letter.created = new Date(data.createdAt);
        letter.updated = new Date(data.updatedAt);
        letter.referenceDate = new Date(data.referenceDate);
        letter.sharedWithCustodians = data.sharedWithCustodians;
        letter.child = data.child;
        letter.remindedAt = data.remindedAt ? new Date(data.remindedAt) : null;
        letter.numCustodians = data.numCustodians;
        letter.isAllowedToEdit = data.isAllowedToEdit ?? false;

        return letter;
    }

    getSignableSignatures() {
        return this.signatures.filter(s => s.signable);
    }
}
